import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Box, Button, Grid, Typography } from '@material-ui/core';

import DenunciaImg from '../../../../../assets/img/denuncia_new.svg';
// import DenunciaImg from '../../../../../assets/img/denuncia.png';
import { useAuthDataContext } from '../../../../../context/auth/auth.provider';
import { useEndorsementsDataContext } from '../../../../../context/endorsements/endorsements.provider';
import { dataLayerPush } from '../../../../../helpers/dataLayerPush';

const FinishStep = () => {
  const history = useHistory();
  const { cleanEndorsementBody } = useEndorsementsDataContext();
  const { user } = useAuthDataContext();

  useEffect(() => {
    dataLayerPush('modificar_poliza_exitosa', user?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  const handleHome = () => {
    redirectHome();
    cleanEndorsementBody();
  };

  return (
    <Grid container>
      <Grid container justify="center">
        <Grid item xs={12}>
          <Box
            my={6}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <img src={DenunciaImg} alt={'denuncia'}></img>
          </Box>
          <Box alignItems="center" justifyContent="center" display="flex"></Box>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} justify="center">
          <Box
            my={4}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <Typography variant="h3" color="primary">
              ¡Ya estamos revisando tu solicitud!
            </Typography>
          </Box>
          <Box
            my={4}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <Typography>
              Te informaremos en cuanto haya un avance en el proceso.
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Grid container justify="center">
        <Grid item xs={12} sm={6}>
          <Box my={4}>
            <Button
              onClick={handleHome}
              variant="contained"
              color="secondary"
              fullWidth={true}
            >
              Volver al inicio
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FinishStep;
